<template>
    <div>
        <v-alert color="info" text>
            {{ $t('Oletusuutiskuvaa käytetään logon sijaan uutisissa mikäli uutisella ei ole omaa kuvaa.') }}
        </v-alert>
        <div v-if="isLoading" class="text-center my-6">
            <VProgressCircular indeterminate></VProgressCircular>
        </div>
        <div v-else>
            <!-- Current Image Display -->
            <div v-if="currentImage" class="current-image-container" style="max-width: 600px;">
                <v-img :src="currentImage" style="max-width: 100%;"></v-img>

                <v-btn color=" error" @click="confirmRemove" :loading="isSubmitting" class="my-4">
                    {{ $t("Poista kuva") }}
                </v-btn>

            </div>

            <!-- Image Upload/Edit -->
            <div v-else class="image-upload-container">
                <div>
                    <croppa v-model="croppa" :width="600" :height="400" initial-size="contain"
                        :placeholder="$t('Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.')"
                        :placeholder-font-size="20" accept=".jpeg,.jpg,.png" :file-size-limit="5000000"
                        @file-size-exceed="onFileSizeExceed" @file-type-mismatch="onFileTypeMismatch"
                        @new-image-drawn="onNewImage"></croppa>
                </div>

                <v-btn color="primary" class="mr-2" @click="saveImage" :loading="isSubmitting" :disabled="!hasImage">
                    {{ $t("Tallenna") }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api';
import adminApi from '@/api/admin';
import "vue-croppa/dist/vue-croppa.css";

export default {
    setup({ emit }) {
        // State
        const isLoading = ref(true);
        const isSubmitting = ref(false);
        const croppa = ref(null);
        const isEditing = ref(false);

        const currentImage = ref(null);

        const hasImage = computed(() => {
            return croppa.value && croppa.value.hasImage();
        });

        // Methods
        const startEditing = () => {
            isEditing.value = true;
        };

        const cancelEdit = () => {
            isEditing.value = false;
            if (croppa.value) {
                croppa.value.remove();
            }
        };

        const saveImage = async () => {
            if (!hasImage.value) return;

            isSubmitting.value = true;
            try {

                const blob = await new Promise(resolve => {
                    croppa.value.generateBlob(
                        blob => resolve(blob),
                        'image/jpeg',
                        0.8
                    );
                });

                const newImageName = croppa.value.chosenFile.name;

                const res = await adminApi.saveDefaultNewsImage(blob, newImageName);
                if (res.ok) {
                    fetchImage();
                }

            } catch (error) {
                console.error('Failed to save image:', error);
            } finally {

            }
            isSubmitting.value = false;
        };

        const confirmRemove = () => {
            if (confirm('Haluatko varmasti poistaa kuvan?')) {
                removeImage();
            }
        };

        const removeImage = async () => {
            isSubmitting.value = true;
            const res = await adminApi.deleteDefaultNewsImage();
            if (res.ok) {
                currentImage.value = null;
            }
            isSubmitting.value = false;
        };

        // Event handlers
        const onFileSizeExceed = () => {
            alert(
                i18n.t(
                    "File size exceeded 5MB limit"
                )
            );
        };

        const onFileTypeMismatch = () => {
            alert(
                i18n.t(
                    "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png."
                )
            );
        };

        const onNewImage = () => {
            // Optional: Add any additional handling when a new image is loaded
        };

        onMounted(() => {
            fetchImage();
        });

        const fetchImage = async () => {
            const res = await adminApi.getDefaultNewsImage();
            if (res.ok && res.data.news_image) {
                currentImage.value = res.data.news_image["full_size"];
            }
            isLoading.value = false;
        }

        return {
            currentImage,
            isLoading,
            isSubmitting,
            croppa,
            isEditing,
            currentImage,
            hasImage,
            startEditing,
            cancelEdit,
            saveImage,
            confirmRemove,
            removeImage,
            onFileSizeExceed,
            onFileTypeMismatch,
            onNewImage
        };
    }
};
</script>

<style scoped>
.news-image-component {
    max-width: 600px;

}
</style>
